// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bpN_oR {
  min-height: 100%;
  display: flex;
  flex-direction: column;
  background: var(--text-neutral-pale);
  width: 100%;
}

.bbG4aU {
  flex: 1;
  display: flex;
  flex-direction: column;
  width: 100%;
  box-sizing: border-box;
  gap: var(--spacing-7);
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/pages/InsideSalesBenefitsLanding/InsideSalesBenefitsLanding.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,oCAAoC;EACpC,WAAW;AACb;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,sBAAsB;EACtB,qBAAqB;AACvB","sourcesContent":[".page {\n  min-height: 100%;\n  display: flex;\n  flex-direction: column;\n  background: var(--text-neutral-pale);\n  width: 100%;\n}\n\n.main {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  box-sizing: border-box;\n  gap: var(--spacing-7);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `bpN_oR`,
	"main": `bbG4aU`
};
module.exports = ___CSS_LOADER_EXPORT___;
